import type React from "react";
import { Link } from "react-router-dom";
import { useGoals } from "@/hooks/useGoals";
import GoalItem from "./components/GoalItem";

const GoalListPage: React.FC = () => {
	const { goals, loading, error } = useGoals();

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;

	return (
		<div className="container mx-auto px-4 py-8">
			<div className="flex justify-between items-center mb-6">
				<h1 className="text-3xl font-bold">目標一覧</h1>
				<Link
					to="/webapp/goals/new"
					className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
				>
					新しい目標を作成
				</Link>
			</div>

			{goals.length === 0 ? (
				<p className="text-gray-500">目標が設定されていません。</p>
			) : (
				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
					{goals.map((goal) => (
						<GoalItem key={goal.id} goal={goal} />
					))}
				</div>
			)}
		</div>
	);
};

export default GoalListPage;
